// src/components/pages/Caixa/boot/applyCaixaBoot.js
import moment from 'moment';

export function applyCaixaBoot({ prev = {}, parametro, empresaId, pessoaId, now = new Date() }) {
    const dataISO = moment(now).startOf('day').format('YYYY-MM-DD');

    return {
        ...prev,

        // quem está abrindo
        supervisorId: prev?.supervisorId ?? pessoaId,
        colaboradorId: prev?.colaboradorId ?? pessoaId,
        // defaults principais
        empresaId: prev?.empresaId ?? empresaId,
        contaId: prev?.contaId ?? parametro?.contaId,
        data: prev?.data ?? dataISO,
        situacaoId: prev?.situacaoId ?? 1, // 1 = Aberto (padrão do teu sistema)
        abertura: prev?.abertura ?? now,
        ativo: prev?.ativo ?? true,
        conferido: prev?.conferido ?? false,

        // campos numéricos default
        troco: prev?.troco ?? 0,
        saldoAbertura: prev?.saldoAbertura ?? 0,
        saldoFechamento: prev?.saldoFechamento ?? 0,

        // totais (evita undefined no painel)
        totalRecebido: prev?.totalRecebido ?? 0,
        totalPago: prev?.totalPago ?? 0,
        totaisPorForma: prev?.totaisPorForma ?? {},
    };
}
